import React from 'react';
import { CardCarousel } from './CardCarousel';
import { CtaButton } from './CtaButton';
import { cardPreview, cardSlides, cta } from '../data/content';
export function CardPreview() {
  if (cardSlides.length === 0) return null;
  return <section className="bg-parchment-light text-ink" data-id="element-55" data-mp="2irsuup8ke4g2">
      <div className="mx-auto max-w-content py-14 lg:py-24" data-id="element-56" data-mp="2dsom1zpjy8q9">
        <div className="mx-auto max-w-2xl px-5 text-center sm:px-6" data-id="element-57" data-mp="2dr51hwwv5bio">
          <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-58" data-mp="1q4f5bc774b5z">
            {cardPreview.title}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-59" data-mp="1ztyoyk2qg91w">
            {cardPreview.subtitle}
          </p>
        </div>

        <div className="mt-10" data-id="element-60" data-mp="1v0ne87usv84p">
          <CardCarousel data-id="element-61" data-mp="17cw49awqf76l" />
        </div>

        <div className="mx-auto mt-10 max-w-xl px-5 text-center sm:px-6" data-id="element-62" data-mp="17buo4s0uzui0">
          <p className="font-display text-xl font-medium italic leading-snug text-ink sm:text-2xl" data-id="element-63" data-mp="12euksove95ul">
            {cardPreview.closing}
          </p>
          <div className="mx-auto mt-7 max-w-md" data-id="element-64" data-mp="npvk12j90af">
            <CtaButton size="block" tone="outlineInk" href="#oferta" data-id="element-65" data-mp="4qm7xa1hc05x">
              {cta.secondary}
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}